import { render, staticRenderFns } from "./Inspector.vue?vue&type=template&id=ab94a228&scoped=true"
import script from "./Inspector.vue?vue&type=script&lang=js"
export * from "./Inspector.vue?vue&type=script&lang=js"
import style0 from "./Inspector.vue?vue&type=style&index=0&id=ab94a228&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab94a228",
  null
  
)

export default component.exports